// Edgeで縦長画像がぼやけるバグの対策
export default class FitImageAdjuster {
  private targets: HTMLCollectionOf<HTMLInputElement>;

  constructor() {
    this.targets = undefined;
  }

  async init(): Promise<void> {
    this.targets = document.getElementsByClassName('p-detailImages__list-image') as HTMLCollectionOf<HTMLInputElement>;
    const sleep = (msec: number): Promise<void> => new Promise<void>(resolve => setTimeout(resolve, msec));

    this.handleWidth('101%');
    await sleep(1000);
    this.handleWidth('100%');
  }

  handleWidth(width: string): void {
    for (let i = 0; i < this.targets.length; i++) {
      const target = this.targets[i];
      target.style.width = width;
    }
  }
}
